var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"style":{"fill":"none"},"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"data-name":"↳color","d":"m-20540-14171 4 4-4 4","transform":"translate(20549.998 14178.999)","style":{"stroke":"#031425","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5px","fill":"none"},"key":1})]);
}

ChevronRight.defaultProps = {"data-name":"icon - chevron right - 24px","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
